import { useRef, useEffect } from "react";

export const useUpdateEffect: typeof useEffect = (effect, deps) => {
    const firstRender = useRef<boolean>(true);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        return effect();
    }, deps);
};
